export default __webpack_public_path__ + "static/media/648.082ce234.jpg";